import { memo } from 'react';

import { useIntl } from '@ezugi/bootstrap/src/hooks/useIntl';

import { drawerToggler } from './GameRightSideDrawer.css';

const intlKeys = {
  myBets: 'games_ui.my_bets',
};

function RightSideDrawerToggler() {
  const locales = useIntl({ keys: intlKeys });

  return (
    <div className={drawerToggler}>
      {locales.myBets}
    </div>
  );
}

export default memo(RightSideDrawerToggler);
